import {
  getParticipantToken,
  importRecoveryToken,
  removeParticipantToken,
} from "@client/realtime/token-store";

export function captureRecoveryCredential(joinCode: string): string | undefined {
  return importRecoveryToken(joinCode) ?? getParticipantToken(joinCode);
}

export function clearInvalidRecoveryCredential(joinCode: string, code: string): void {
  if (code === "ROOM_EXPIRED" || code === "ROOM_NOT_FOUND" || code === "UNAUTHORIZED") {
    removeParticipantToken(joinCode);
  }
}

export function shouldRequestSync(input: {
  recovered: boolean;
  currentVersion: number;
  incomingVersion?: number;
}): boolean {
  return (
    !input.recovered ||
    input.currentVersion < 0 ||
    (input.incomingVersion !== undefined && input.incomingVersion > input.currentVersion + 1)
  );
}

export function shouldReplaceSnapshot(
  currentVersion: number,
  incomingVersion: number,
  explicitSync: boolean,
): boolean {
  return incomingVersion > currentVersion || (explicitSync && incomingVersion === currentVersion);
}
